import { getApiCall, postApiCall, putApiCall } from '../../utils/request';
import { returnErrors } from './errorAction';
import { ADD_SCHEDULE, ACTIVATE_CLASS, DELETE_SCHEDULE, EDIT_SCHEDULE, GET_SCHEDULE, GET_SCHEDULE_FACULTIES, GET_SCHEDULE_SECTIONS, GET_SCHEDULE_STUDENTS, GET_SCHEDULE_SUBJECTS, GET_SCHEDULE_CLASS_AND_AFFILIATION, GET_CLASS_STUDENTS, GET_CLASS_SSCHEDULES, GET_CLASS_SCHEDULES, MARK_PRESENT, MARK_ABSENT, MARK_INDIVIDUAL, CHANGE_LEAVE_STATUS, GET_ATTENDANCE_FACULTY_LIST, RESET_CLASS_AND_AFFILIATION, GET_STUDENT_SCHEDULE, GET_STUDENT_FACULTY_LIST, GET_STUDENT_SUBJECT_LIST, RESET_STUDENTS_AND_SECTIONS } from '../Types/types';
import axios from 'axios';
import { MdOutlineDataExploration } from 'react-icons/md';
const API_KEY = process.env.REACT_APP_API_KEY;

export const getSchedule = (page, size, search, subjectId, chapterId, topicId, selectedStatus, facultyId) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/schedule/list?page=${page}&size=${size}&search=${search}&subject_id=${subjectId}&chapter_id=${chapterId}&topic_id=${topicId}&status=${selectedStatus}&faculty_id=${facultyId}`);
        dispatch({ type: GET_SCHEDULE, payload: response.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const addSchedule = (data) => async (dispatch) => {
    try {
        const response = await postApiCall('admin/schedule/create', data);
        dispatch({ type: ADD_SCHEDULE, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const editSchedule = (data) => async (dispatch) => {
    try {
        const response = await putApiCall('admin/schedule/update', data);
        dispatch({ type: EDIT_SCHEDULE, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const deleteClass = (data) => async (dispatch) => {
    try {
        const response = await axios({
            method: 'delete',
            url: API_KEY + 'admin/schedule/delete',
            data: data,
            headers: { 
                'Authorization': 'Bearer ' + localStorage.getItem('loginToken'),
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
        throw error; // Re-throw the error to handle it in the component
    }
}

export const activateClass = (data) => async (dispatch) => {
    try {
        const response = await putApiCall(`admin/schedule/status`, data);
        if (response.data.success) {
            dispatch({ type: ACTIVATE_CLASS, payload: data});
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
}

export const getFaculties = (affiliation_id, subject_id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/schedule/faculties?affiliation_id=${affiliation_id}&subject_id=${subject_id}`);
        dispatch({ type: GET_SCHEDULE_FACULTIES, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const getSubjects = () => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/schedule/subjects`);
        dispatch({ type: GET_SCHEDULE_SUBJECTS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const getSections = (classroom_id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/schedule/sections?classroom_id=${classroom_id}`);
        dispatch({ type: GET_SCHEDULE_SECTIONS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const getStudents = (classroom_id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/schedule/students?classroom_id=${classroom_id}`);
        dispatch({ type: GET_SCHEDULE_STUDENTS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const getClassAndAffiliation = (subject_id) => async (dispatch) => {
    try {
        dispatch({type: RESET_STUDENTS_AND_SECTIONS});
        const response = await getApiCall(`admin/schedule/subject/class/affiliation?subject_id=${subject_id}`);
        return dispatch({ type: GET_SCHEDULE_CLASS_AND_AFFILIATION, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const resetClassAndAffiliation = () => async (dispatch) => {
     return dispatch({ type: RESET_CLASS_AND_AFFILIATION })
}

export const selectAllClasses = (checked) => async (dispatch) => {
    return dispatch({ type: 'Select_All_Classes', payload: checked })
}

export const checkOneClass = (id, checked) => async (dispatch) => {
    return dispatch({ type: 'Select_One_Class', payload: { id, checked } })
}

//Attendance
export const getClassStudents = (class_id, search) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/attendance/students?class_id=${class_id}&search=${search}`);
        return dispatch({ type: GET_CLASS_STUDENTS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const markAttendance = (data) => async (dispatch) => {
    try {
         const response = await postApiCall('admin/attendance/mark', data);
         return response;
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const getClassSchedules = (search, subjectId, chapterId, topicId, selectedStatus, facultyId, page, limit) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/attendance/class/schedules?search=${search}&subject_id=${subjectId}&chapter_id=${chapterId}&topic_id=${topicId}&status=${selectedStatus}&faculty_id=${facultyId}&page=${page}&limit=${limit}`);
        return dispatch({ type: GET_CLASS_SCHEDULES, payload: response.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const getFacultyList = () => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/users/staff/all`);
        return dispatch({ type: GET_ATTENDANCE_FACULTY_LIST, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const markPresent = () => async (dispatch) => {
    return dispatch({ type: MARK_PRESENT })
}

export const markAbsent = () => async (dispatch) => {
    return dispatch({ type: MARK_ABSENT })
}

export const changeStatus = (present, id) => async (dispatch) => {
    console.log(present, id)
    return dispatch({ type: MARK_INDIVIDUAL, payload: { present, id } })
}

export const changeLeaveStatus = (val, id) => async (dispatch) => {
    return dispatch({ type: CHANGE_LEAVE_STATUS, payload: { val, id } })
}

export const getStudentSchedule = (search, date, faculty_id, subject_id, page, limit) => async(dispatch) => {
    try {
        const response = await getApiCall(`student/schedule/classes?&search=${search}&date=${date}&faculty_id=${faculty_id}&subject_id=${subject_id}&page=${page}&limit=${limit}`);
        return dispatch({ type: GET_STUDENT_SCHEDULE, payload: response.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const getStudentSubjectList = () => async (dispatch) => {
    try {
        const response = await getApiCall(`student/schedule/subjects`);
        dispatch({ type: GET_STUDENT_SUBJECT_LIST, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
}

export const getStudentFacultyList = () => async (dispatch) => {
    try {
        const response = await getApiCall(`student/schedule/faculties`);
        dispatch({ type: GET_STUDENT_FACULTY_LIST, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
};